<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: "app",
    mounted() {},
};
</script>

<style>
body {
    margin: 0;
    padding: 0;
    background-color: rgba(240, 242, 245, 1);
}
#app {
    margin: 0;
    padding: 0;
}

/* 设置滚动条的样式 */

::-webkit-scrollbar {
    width: 3px;
    height: 6px;
}

/* 滚动槽 */

::-webkit-scrollbar-track {
    -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);

    border-radius: 10px;
}

/* 滚动条滑块 */

::-webkit-scrollbar-thumb {
    border-radius: 10px;

    background: rgba(0, 0, 0, 0.1);

    -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}

::-webkit-scrollbar-thumb:window-inactive {
    background: rgba(25, 137, 250, 1);
}
</style>
